import { ArrowLeft, Bot } from "lucide-react";

export function ChatbotHeader({ step, activePersona, onBack }) {
  return (
    <div className="flex items-center gap-2 px-3 py-2.5 border-b border-rp-border bg-rp-bg shrink-0" data-testid="chatbot-header">
      {step === "chat" && (
        <button
          type="button"
          onClick={onBack}
          className="p-1 rounded hover:bg-rp-surface shrink-0"
          aria-label="Back to persona picker"
          data-testid="chatbot-back"
        >
          <ArrowLeft className="h-4 w-4 text-rp-textDim" />
        </button>
      )}
      <Bot className="h-5 w-5 text-emerald-400 shrink-0" />
      <div className="flex-1 min-w-0">
        <div
          className="text-sm font-semibold text-rp-text truncate"
          title={step === "chat" && activePersona ? `${activePersona.name} · ${activePersona.role}` : "RiskPedia AI Mentors"}
        >
          {step === "chat" && activePersona
            ? `${activePersona.name} · ${activePersona.role}`
            : "RiskPedia AI Mentors"}
        </div>
        {step === "picker" && (
          <div className="text-[10px] text-rp-textFaint">Pick a mentor to start</div>
        )}
      </div>
    </div>
  );
}
